module.exports = __webpack_public_path__ + "img/2faa7e3.jpg";